// Helper to format currency numbers (VND)
export const formatCurrency = (value) => {
  if (value === undefined || value === null) return "0";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "VND",
      maximumFractionDigits: 2,
    }).format(value);
  } catch (e) {
    return String(value);
  }
};
